module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-item-answer"
  }, [(_vm.type === 1) ? _c('div', {
    staticClass: "sequence"
  }, [_c('div', {
    staticClass: "box-answer-input"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.value))]), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": 'answer' + _vm.qd_index,
      "id": 'answer' + _vm.qd_index + '_' + _vm.id + _vm.value
    },
    domProps: {
      "value": _vm.id,
      "checked": _vm.isChecked
    },
    on: {
      "click": function($event) {
        return _vm.onClickChecked($event)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'answer' + _vm.qd_index + '_' + _vm.id + _vm.value
    }
  })])]), _c('div', {
    staticClass: "material-icons",
    on: {
      "click": _vm.deleteAnswer
    }
  }, [_vm._v("delete")])]) : _vm._e(), (_vm.$isMobile()) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _c('div', {
    staticClass: "froala",
    style: (_vm.type === 2 ? 'width: 100%;' : 'width: calc(100% - 60px);')
  }, [_c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.configFroala
    },
    on: {
      "input": function($event) {
        return _vm.changeAnswer($event)
      }
    },
    model: {
      value: (_vm.lastContent),
      callback: function($$v) {
        _vm.lastContent = $$v
      },
      expression: "lastContent"
    }
  }), _c('input', {
    staticClass: "hide",
    attrs: {
      "id": 'froala_answer' + _vm.qd_index + '_' + _vm.id + _vm.value
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1082898c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question/Answer/index.vue
// module id = 1486
// module chunks = 0